import React from 'react';
import patients from '../../../../../../services/patients/index';
import { NavigationFullscreenExit, Toolbar } from 'material-ui';
import LoadingComponent from '../../../../../../components/loading/index';
import './style.css';
import ToolbarComponent from './components/toolbar/index';
import PatientInfo from './components/patient-info/index';
import PatientTabs from './scenes/patient-tabs/index';

export default class PatientDetails extends React.Component {
    state = {
        patient: null,
        loading: true
    }

    componentWillMount() {
        let {patient} = this.props.match.params;
        patients.findOne({_id: patient}, (err, patient) => {
            this.setState({patient: patient, loading: false});
        })
    }

    setPatient = (patient) => {
        this.setState({patient: patient})
    }

    render() {
        if(this.state.loading)
            return <LoadingComponent />

        return (
            <div className="PatientDetails">
                <ToolbarComponent title="Detalles de cliente" />
                <PatientInfo setPatient={this.setPatient} user={this.props.user} patient={this.state.patient} />
                <PatientTabs patient={this.state.patient} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/registers/scenes/patient-details/index.js